/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_SendingInputs */

const en_cp_form_sending = /** @type {(inputs: Cp_Form_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const id_cp_form_sending = /** @type {(inputs: Cp_Form_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengirim…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Cp_Form_SendingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_sending = /** @type {((inputs?: Cp_Form_SendingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_SendingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_sending(inputs)
	return en_cp_form_sending(inputs)
});